import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ConductorAuthProvider } from './contexts/ConductorAuthContext';
import { Toaster } from './components/ui/sonner';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ConductorRoute } from './components/ConductorRoute';
import { DashboardLayout } from './components/DashboardLayout';
import { SuperAdminLayout } from './components/SuperAdminLayout';
import { LandingPage } from './pages/LandingPage';
import { Login } from './pages/Login';
import { RecuperarPasswordPage } from './pages/RecuperarPasswordPage';
import { RestablecerPasswordPage } from './pages/RestablecerPasswordPage';
import { CalendarioPage } from './pages/CalendarioPage';
import { SolicitarViajePage } from './pages/SolicitarViajePage';
import { EmpresasPage } from './pages/EmpresasPage';
import { UsuariosPage } from './pages/UsuariosPage';
import { ClientesPage } from './pages/ClientesPage';
import { VehiculosPage } from './pages/VehiculosPage';
import { ConductoresPage } from './pages/ConductoresPage';
import { TarifasPage } from './pages/TarifasPage';
import { TiposViajePage } from './pages/TiposViajePage';
import { ReportesPage } from './pages/ReportesPage';
import { GestionPage } from './pages/GestionPage';
import { ConfiguracionPage } from './pages/ConfiguracionPage';
import { MisCentrosCostoPage } from './pages/MisCentrosCostoPage';
import { MisUsuariosPage } from './pages/MisUsuariosPage';
import { SuperAdminEmpresasPage } from './pages/superadmin/EmpresasPage';
import { SuperAdminAdministradoresPage } from './pages/superadmin/AdministradoresPage';
import { SuperAdminConfiguracionPage } from './pages/superadmin/ConfiguracionPage';
import { ConductorCambiarPassword } from './pages/conductor/ConductorCambiarPassword';
import { ConductorServicios } from './pages/conductor/ConductorServicios';
import { ConductorServicioDetail } from './pages/conductor/ConductorServicioDetail';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ConductorAuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/recuperar-password" element={<RecuperarPasswordPage />} />
          <Route path="/restablecer-password" element={<RestablecerPasswordPage />} />
          
          {/* SuperAdmin Routes */}
          <Route path="/superadmin" element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <SuperAdminLayout><SuperAdminEmpresasPage /></SuperAdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/superadmin/empresas" element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <SuperAdminLayout><SuperAdminEmpresasPage /></SuperAdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/superadmin/administradores" element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <SuperAdminLayout><SuperAdminAdministradoresPage /></SuperAdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/superadmin/configuracion" element={
            <ProtectedRoute allowedRoles={['superadmin']}>
              <SuperAdminLayout><SuperAdminConfiguracionPage /></SuperAdminLayout>
            </ProtectedRoute>
          } />
          
          {/* Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <DashboardLayout />
            </ProtectedRoute>
          }>
            <Route path="calendario" element={<CalendarioPage />} />
            <Route path="solicitar" element={<SolicitarViajePage />} />
            <Route path="clientes" element={<ClientesPage />} />
            <Route path="empresas" element={<EmpresasPage />} />
            <Route path="usuarios" element={<UsuariosPage />} />
            <Route path="vehiculos" element={<VehiculosPage />} />
            <Route path="conductores" element={<ConductoresPage />} />
            <Route path="tarifas" element={<TarifasPage />} />
            <Route path="tipos-viaje" element={<TiposViajePage />} />
            <Route path="reportes" element={<ReportesPage />} />
            <Route path="gestion" element={<GestionPage />} />
            <Route path="configuracion" element={<ConfiguracionPage />} />
          </Route>

          {/* Client Routes */}
          <Route path="/cliente" element={
            <ProtectedRoute allowedRoles={['client']}>
              <DashboardLayout />
            </ProtectedRoute>
          }>
            <Route path="calendario" element={<CalendarioPage />} />
            <Route path="solicitar" element={<SolicitarViajePage />} />
            <Route path="centros-costo" element={<MisCentrosCostoPage />} />
            <Route path="usuarios" element={<MisUsuariosPage />} />
            <Route path="reportes" element={<ReportesPage />} />
          </Route>

          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Conductor Routes */}
          <Route path="/conductor/login" element={<Navigate to="/login" replace />} />
          <Route path="/conductor/cambiar-password" element={
            <ConductorRoute><ConductorCambiarPassword /></ConductorRoute>
          } />
          <Route path="/conductor" element={
            <ConductorRoute><ConductorServicios /></ConductorRoute>
          } />
          <Route path="/conductor/servicio/:id" element={
            <ConductorRoute><ConductorServicioDetail /></ConductorRoute>
          } />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
      </ConductorAuthProvider>
    </AuthProvider>
  );
}

export default App;